<template>
  <max-z-index :show="currentValue">
    <div @touchmove="onTouchMove">
      <transition :name="maskTransition">
        <masks
          :mshow="currentValue"
          :mopacity = "mOpacity"
          :mbackground = "mBackground"
          :mclass = "maskClass"
          @maskTap="maskHide">
        </masks>
      </transition>
      <transition :name="dialogTransition" >
        <div v-show="currentValue" style="z-index:1001!important;" v-bind:class="dialogStyle">
          <slot></slot>
        </div>
      </transition>
    </div>
  </max-z-index>
</template>
<script>
import Masks from '@/components/mask/index.vue'
import MaxZIndex from '@/components/max-z-index/index.vue'

export default {
  components:{
    Masks,
    MaxZIndex
  },
  props: {
    mshow: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'beast-mask'
    },
    // maskStyle: {
    //   type: String,
    //   default: 'beast__mask'
    // },
    dialogTransition: {
      type: String,
      default: 'beast-dialog'
    },
    dialogStyle: {
      type: String,
      default: 'beast__dialog'
    },
    mask: {
      type: Boolean,
      default: true
    },
    maskTouchHide: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: Boolean,
      default: true
    },
    maskOpacity: {
      // type: Number,
      default: 0.4
    },
    maskBackground: {
      default: '#000000'
    },
    maskClass: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  created () {
    if (typeof this.mshow !== 'undefined') {
      this.currentValue = this.mshow
    }
  },
  data () {
    return {
      currentValue: false
    }
  },

  computed:{
    mOpacity: function(){
      return this.mask ? parseFloat(this.maskOpacity) : 0
    },
    mBackground: function () {
      return this.mask ? this.maskBackground : '#000000'
    }
  },

  watch: {
    mshow (val) {
      this.currentValue = val
    },
    currentValue (val) {
      val || this.$emit('mask-hide')
    }
  },
  methods: {
    onTouchMove: function (event) {
      !this.scroll && event.preventDefault()
    },
    maskHide: function (){
      this.mask && this.maskTouchHide && (this.currentValue = false)
    }
  }
}
</script>
<style lang="stylus">
  @import '../../common/styl/global'

  .beast-mask-enter, .beast-mask-leave-active
      opacity 0

  .beast-mask-leave-active, .beast-mask-enter-active
    transition opacity 300ms

  .beast-dialog-enter-active,.beast-dialog-leave-active
    opacity 1
    transition-duration 300ms
    transform translate(-50%, -50%) scale(1)!important
    transition-property transform, opacity!important

  .beast-dialog-enter, .beast-dialog-leave-active
    opacity 0
    transform translate(-50%, -50%) scale(1.185)!important
  .beast__mask
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    z-index 1000
    background rgba(0, 0, 0, 0.4)
  .beast__dialog
    position fixed
    top 50%
    left 50%
    transform translate(-50%, -50%)

</style>



// WEBPACK FOOTER //
// index.vue?34e09ccc